<template>
  <footer class="footer">
    <div class="container">
      <b-row><b-col><hr/></b-col></b-row>
      <b-row>
        <!-- <nav class="pull-left">
          <ul>
            <li>
              <a href="#"> About Us </a>
            </li>
            <li>
              <a href="#"> Licenses </a>
            </li>
          </ul>
        </nav> -->
        <b-col md="6" class="small align-left">
          © 2020 <i class="fa fa-rocket rocket"></i> Food for Benjamin Ltd <br/>
          Registered in England &amp; Wales: 6893865
        </b-col>
        <b-col md="6" class="small align-right">
          v0.1-020-beta<br/>
          <router-link v-if="!playerId" :to="{ name: 'players' }">Log In</router-link>
        </b-col>
      </b-row>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  computed: {
    ...mapState({
      player: (state) => state.session.player,
    }),
    playerId() {
      return this.player && this.player.id;
    }
  },
};
</script>

<style scoped>
.footer {
  margin-top: 48px !important;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
</style>